import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space, Switch } from 'antd'
import { PrimaryButton } from 'Components/button'
import { MerchantType } from 'helpers/constanst'
import { isFormRequired, isFormError, formValidation, getStatus, formatDateTime } from 'helpers/format'
import { DetailReq, UpdateReq, RejectReq, ApproveReq } from 'Store/merchants/types'
import {
  getMerchantsDetailAPI,
  updateMerchantsAPI,
  rejectMerchantsAPI,
  approveMerchantsAPI,
} from 'Store/merchants/api'
import { selectActionEvent, selectDetail, selectDetailEvent } from 'Store/merchants/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/merchants/actions'
import EventModal from 'Components/modal/EventModal'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import EditMapDrawer from './EditMapDrawer'
import { ConfirmDailog, ConfirmQuestion } from 'Components/modal'
import { MerchantAccount, MerchantDetail, MerchantDocument, MerchantAddress } from './components'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
}

const CouponDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    mode,
    detail,
    detailEvent,
  } = props
  const isApproveMode = mode === 'approve'
  const isIndividual = detail?.type === MerchantType.INDIVIDUAL

  const individualRequired = ['document_personal_id', 'document_personal_picture', 'document_bank']
  const coporateRequired = [
    'document_bank',
    'document_company_certificate',
    'document_commercial_registration',
    'document_commercial_copy_of_vat',
    'document_company_tax_id',
  ]
  const requireFeild = isIndividual ? individualRequired : coporateRequired
  const initForm = {} as UpdateReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [isEditMap, setEditMap] = useState(false)
  const [rejectDialog, setRejectDialog] = useState(false)
  const [approveDialog, setApproveDialog] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      // setFormData(cloneDeep(initForm))
      setFormError([])
    }
    if (visible && id) {
      onGetDetail()
    }
  }, [visible])

  useEffect(() => {
    if (id > 0) {
      const form = {
        ...detail,
      } as UpdateReq
      setFormData({ ...form })
    }
  }, [detail])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const onGetDetail = (): void => {
    if (!id) return
    const req: DetailReq = {
      id,
    }
    dispatch(getMerchantsDetailAPI(req, currentUser.accessToken))
  }

  const onUpdate = (): void => {
    if (!validateForm()) return
    const req: UpdateReq = {
      ...formData,
      id,
    }
    dispatch(updateMerchantsAPI({ data: req }, currentUser.accessToken))
  }

  const onReject = (reason: string): void => {
    const req: RejectReq = {
      id,
      reject_reason: reason,
    }
    dispatch(rejectMerchantsAPI(req, currentUser.accessToken))
  }

  const onApprove = (): void => {
    const req: ApproveReq = {
      id,
    }
    dispatch(approveMerchantsAPI(req, currentUser.accessToken))
  }

  const onUpdateData = (val: any, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
    if (rejectDialog) {
      setRejectDialog(false)
    }
    if (approveDialog) {
      setApproveDialog(false)
    }
  }

  const onSaveEditMap = (lat: number, long: number) => {
    setFormData({
      ...formData,
      lat: lat,
      long: long,
    })
    setEditMap(false)
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const editFooter = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton text="ยืนยันการแก้ไขข้อมูล" onClick={onUpdate} />
    </Space>
  )

  const approveFooter = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="อนุมัติร้านค้า" btnType="Approve" onClick={() => setApproveDialog(true)} />
      <PrimaryButton text="ไม่อนุมัติร้านค้า" btnType="Reject" onClick={() => setRejectDialog(true)} />
    </Space>
  )

  const FooterContent = isApproveMode ? approveFooter : editFooter

  const EditMapContent = (
    <EditMapDrawer
      isShow={isEditMap}
      onClose={() => setEditMap(false)}
      onSave={onSaveEditMap}
      data={formData}
    />
  )

  const renderMerchantSetting = () => {
    const isMasterProduct = formData?.master_product || false
    return (
      <BoxWrapper>
        <BoxTitle>ตั้งค่าร้านค้า</BoxTitle>
        <Col md={24} xs={24}>
          <Switch
            checked={isMasterProduct}
            onChange={val => onUpdateData(val, 'master_product')}
            disabled={isApproveMode}
          />
          &nbsp;&nbsp;
          <InfoTitle>{`สินค้าตัวกลาง : `}</InfoTitle>
          <InfoValue>{`${getStatus(isMasterProduct)}`}</InfoValue>
        </Col>
      </BoxWrapper>
    )
  }

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title="ไม่อนุมัติร้านค้า"
      placeholder="เช่น ร้านค้าอัพโหลดเอกสารไม่ครบถ้วน..."
      confirmBtnTxt="ไม่อนุมัติ"
      isShow={rejectDialog}
      handleOk={(remark: string) => onReject(remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title="ยืนยันอนุมัติร้านค้า"
      description="คุณแน่ใจที่จะอนุมัติร้านค้านี้หรือไม่?"
      confirmBtnTxt="อนุมัติ"
      isShow={approveDialog}
      handleOk={onApprove}
      handleCancel={() => setApproveDialog(false)}
      loading={event.IsLoading}
    />
  )

  const title = (
    <>
      <span>ชื่อร้านค้า: {detail?.name}</span>
      <br />
      <InfoTitle>วันที่สมัคร: {formatDateTime(detail?.created_at || '')}</InfoTitle>
    </>
  )

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width="70%"
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={16}>
        <Col md={10} xs={24}>
          <MerchantDetail
            mode={mode}
            formData={formData}
            detail={detail}
            onUpdateData={onUpdateData}
            token={currentUser?.accessToken}
          />
        </Col>
        <Col md={14} xs={24}>
          <Row gutter={16}>
            <Col md={24} xs={24}>
              <MerchantAddress mode={mode} setEditMap={setEditMap} formData={formData} detail={detail} />
            </Col>
            <Col md={24} xs={24}>
              <MerchantAccount detail={detail} />
            </Col>
            <Col md={24} xs={24}>
              {renderMerchantSetting()}
            </Col>
            <Col md={24} xs={24}>
              <MerchantDocument
                detail={detail}
                onUpdateData={onUpdateData}
                token={currentUser?.accessToken}
                formData={formData}
                setFormData={setFormData}
                isError={isError}
                isRequired={isRequired}
                readOnly={isApproveMode}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {EditMapContent}
      {ConfirmRejectDailog}
      {ConfirmApproveDailog}
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(CouponDetail)
